import React, { Component } from "react";

class PayrollFooterDisplay extends Component {
  renderSignatureBlock = (section, index, totalSections) => {
    return (
      <div 
        className="col-md-6" 
        key={section.id || index}
        style={{ 
          paddingTop: "0",
          paddingRight: "12px",
          paddingBottom: "12px",
          paddingLeft: "0",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
          <span 
            style={{
              display: "inline-flex",
              alignItems: "center",
              backgroundColor: "#f8f9fa",
              border: "1px solid #dee2e6",
              padding: "4px 8px",
              marginRight: "8px",
              fontWeight: "bold",
              borderRadius: "4px",
              flexShrink: 0,
            }}
          >
            {section.label}.
          </span>
          <span
            style={{
              fontSize: `${section.textStyle?.fontSize || 12}px`,
              fontWeight: section.textStyle?.bold ? "bold" : "normal",
              fontStyle: section.textStyle?.italic ? "italic" : "normal",
              color: section.textStyle?.color || "#000000",
              flex: 1,
            }}
          >
            {section.text}
          </span>
        </div>
        
        <div>
          <div className="d-flex justify-content-between align-items-start" style={{ marginTop: "20px", paddingLeft: "20px" }}>
            <div style={{ flex: 1, marginRight: "20px" }}>
              <div style={{ borderBottom: "1px solid #000", marginBottom: "5px" }}></div>
              <div
                style={{
                  fontSize: `${section.nameStyle?.fontSize || 14}px`,
                  fontWeight: section.nameStyle?.bold ? "bold" : "normal",
                  fontStyle: section.nameStyle?.italic ? "italic" : "normal",
                  color: section.nameStyle?.color || "#000000",
                  marginBottom: "5px",
                  textAlign: "center",
                }}
              >
                {section.name}
              </div>
              <div
                style={{
                  fontSize: `${section.positionStyle?.fontSize || 12}px`,
                  fontWeight: section.positionStyle?.bold ? "bold" : "normal",
                  fontStyle: section.positionStyle?.italic ? "italic" : "normal",
                  color: section.positionStyle?.color || "#000000",
                  textAlign: "center",
                }}
              >
                {section.position}
              </div>
            </div>
            
            <div style={{ width: "200px" }}>
              <div style={{ borderBottom: "1px solid #000", marginBottom: "5px" }}></div>
              <div style={{ fontSize: "12px", color: "#000", textAlign: "center" }}>Date</div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { footer } = this.props;
    
    // Handle both new array format and old format
    let sections = footer?.sections;
    if (!sections) {
      // Migrate from old format if needed
      const defaultData = {
        A: {
          visible: true,
          label: "A",
          text: "CERTIFIED: Services duly rendered as stated.",
          name: "RHUBIE M. TAMAYO",
          position: "Acting Chief, Compensation & Employee Benefits Section",
        },
        B: {
          visible: true,
          label: "B",
          text: "CERTIFIED: Supporting documents complete and proper, and cash available in the amount of ₱ 0.00",
          name: "CHESTER KEVIN S. SY",
          position: "Chief, Accounting Section",
        },
        C: {
          visible: false,
          label: "C",
          text: "Approved for Payment",
          name: "MARY ANN O. CARANTO",
          position: "Chief Administrative Division",
        },
        D: {
          visible: false,
          label: "D",
          text: "CERTIFIED: Each employee whose name appears on the payroll has been paid the amount as indicated opposite his/her name.",
          name: "LILIBETH F. LINTAG",
          position: "Disbursing Officer",
        },
      };

      sections = [];
      ['A', 'B', 'C', 'D'].forEach((letter, index) => {
        const visible = footer?.[`section${letter}_visible`] ?? defaultData[letter].visible;
        if (visible) {
          sections.push({
            id: index,
            label: footer?.[`section${letter}_label`] ?? defaultData[letter].label,
            text: footer?.[`section${letter}_text`] || defaultData[letter].text,
            name: footer?.[`section${letter}_name`] || defaultData[letter].name,
            position: footer?.[`section${letter}_position`] || defaultData[letter].position,
            textStyle: footer?.[`section${letter}_textStyle`] || { color: "#000000", fontSize: 12, bold: false, italic: false },
            nameStyle: footer?.[`section${letter}_nameStyle`] || { color: "#000000", fontSize: 14, bold: true, italic: false },
            positionStyle: footer?.[`section${letter}_positionStyle`] || { color: "#000000", fontSize: 12, bold: false, italic: false },
          });
        }
      });
    }

      return (
        <div className="overflow-auto">
          <div className="footer-preview bg-white border rounded " style={{ minWidth: "800px", maxWidth: "1000px", margin: "0 auto" }}>
            <div className="row g-0">
              {sections.map((section, index) =>
              this.renderSignatureBlock(section, index, sections.length)
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default PayrollFooterDisplay;
